<template>
<div>
    <v-container>
        <div :class="{'mx-9':$vuetify.breakpoint.lgAndUp, 'mx-0': $vuetify.breakpoint.mdAndDown}">
        <v-toolbar flat color="#F0FFEA" height="30" >
            <v-toolbar-title style="color:#62AE32" class="headline">{{this.$store.state.community.communitybyid.community_name}}</v-toolbar-title>
        </v-toolbar>

        <div class="mt-6">
            <v-card class="ml-4" color="#F0FFEA" max-width="400" flat> 
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                    <span style="font-size:13px; color:#615D5D">Community Code</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            solo
                            flat
                            dense
                            v-model="communityCode"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                    <span style="font-size:13px; color:#615D5D">Address</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-textarea
                            readonly
                            solo
                            flat
                            auto-grow="true" 
                            v-model="address"
                            style="font-size:14px"
                            class="black--text"
                        ></v-textarea>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Email</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="email"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Website Url</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="website"
                            style="font-size:14px"
                            class="black-text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Contact No</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="contact"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">No of Members</span>                  
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="number"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card>
        </div>
        
        <v-tabs color="#B45C5C" background-color="#F0FFEA" class="mt-4">
            <v-tab class="black--text">All Members</v-tab>
            <v-tab class="black--text">Claims</v-tab>
            <v-tab-item>
                <v-card>
                    <template>
                    <v-data-table
                    :headers="headers"
                    :items="Members"
                    :class="elevation-1"
                    class="px-5"
                    :items-per-page="5"
                    :search="search"
                    no-data-text="Community Has No Memeber"
                    >
                    <template  v-slot:top>
                        <v-toolbar flat color="white">
                            <v-spacer></v-spacer>
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                                color="#08911B"
                                style="width:20%"
                            ></v-text-field>
                        </v-toolbar>
                        <!-- <v-divider class=""></v-divider> -->
                        <br>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <div @click="getName(item.Id)" style="color:#B45C5C; cursor: pointer;">
                            View more
                        </div>
                    </template>
                    <!-- <template v-slot:item.actionDel="{ item }">
                        <v-dialog persistent v-model="dialog" max-width="400px">
                            <template v-slot:activator="{ on }">
                                <v-card-text class="text-center">
                                    <v-icon
                                        style="color:#FF5F58; cursor: pointer;"
                                        v-on="on"
                                        @click="alert(item.name)"
                                    >
                                        mdi-delete
                                    </v-icon>
                                </v-card-text>
                                
                            </template>
                            <v-card>
                                <v-card-title>
                                <span class=" black--text">Delete Member</span>
                                </v-card-title>

                                <v-card-text>
                                <v-container>
                                    <v-card-text class="black--text">Are you sure you want to delet Ade Ojo? Every policy and claims tied to him will be deleted too</v-card-text>
                                </v-container>
                                </v-card-text>

                                <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="#62AE32" text @click="save">No</v-btn>
                                <v-btn color="#62AE32" text @click="close">Yes</v-btn>
                                
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </template> -->

                    </v-data-table>
                </template>
                </v-card>
            </v-tab-item>

            <!-- claims tab -->
            <v-tab-item>
            <v-card>
                    <template>
                    <v-data-table
                    :headers="claimHeaders"
                    :items="Claims"
                    :class="elevation-1"
                    class="px-5"
                    :items-per-page="5"
                    :search="search"
                    :loading="loader"
                    no-data-text="Community Has No Claims For Display"
                    >
                    <template  v-slot:top>
                        <v-toolbar flat color="white">
                            <v-text-field
                                v-model="searchClaims"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                                color="#08911B"
                                style="width:20%"
                            ></v-text-field>
                            <v-spacer></v-spacer>
                            <v-select outlined label="claim status..." color="#08911B" :items="claimStatus" v-model="selectClaimStatus" class="mt-6" dense style="width:10%" @change="onChange($event)">

                            </v-select>
                        </v-toolbar>
                        <!-- <v-divider class=""></v-divider> -->
                        <br>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <div @click="getClaims(item.id)" style="color:#B45C5C; cursor: pointer;">
                            Details
                        </div>
                    </template>
                    <!-- <template v-slot:item.flag="{ item }">
                        <v-chip :color="getColor(item.flag)" dark>{{ item.flag }}</v-chip>
                    </template> -->
                    </v-data-table>
                </template>
            </v-card>
            </v-tab-item>
    </v-tabs>

    <v-toolbar flat color="#F0FFEA" height="30" class="mt-5 my-3">
        <v-toolbar-title style="color:#62AE32" class="headline">ADMINS</v-toolbar-title>
    </v-toolbar>


    <!-- ADMINS -->
    <v-card>
        <template>
        <v-data-table
        :headers="headersAdmins"
        :items="Admins"
        :class="elevation-1"
        class="px-5"
        :items-per-page="5"
        :search="searchAdmin"
        no-data-text="No Admin Attached To This Community"

        >
        <template  v-slot:top>
            <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="searchAdmin"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                    color="#08911B"
                    style="width:20%"
                ></v-text-field>
            </v-toolbar>
            <!-- <v-divider class=""></v-divider> -->
            <br>
        </template>
        <template v-slot:item.action="{ item }">
            <div @click="getName(item.Id)" style="color:#B45C5C; cursor: pointer;">
                View more
            </div>
        </template>
        <!-- <template v-slot:item.actionDel="{ item }">
            <v-dialog persistent v-model="dialog" max-width="400px">
                <template v-slot:activator="{ on }">
                    <v-card-text class="text-center">
                        <v-icon
                            style="color:#FF5F58; cursor: pointer;"
                            v-on="on"
                            @click="alert(item.name)"
                        >
                            mdi-delete
                        </v-icon>
                    </v-card-text>
                    
                </template>
                <v-card>
                    <v-card-title>
                    <span class=" black--text">Delete Member</span>
                    </v-card-title>

                    <v-card-text>
                    <v-container>
                        <v-card-text class="black--text">Are you sure you want to delet Ade Ojo? Every policy and claims tied to him will be deleted too</v-card-text>
                    </v-container>
                    </v-card-text>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#62AE32" text @click="save">No</v-btn>
                    <v-btn color="#62AE32" text @click="close">Yes</v-btn>
                    
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template> -->

        </v-data-table>
        </template>
    </v-card>
    <!-- Loss Assessors here -->

    <v-toolbar flat color="#F0FFEA" height="30" class="mt-5 my-3">
        <v-toolbar-title style="color:#62AE32" class="headline">LOSS ASSESSORS</v-toolbar-title>
    </v-toolbar>
    
    <v-card>
        <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
                v-model="searchAssessor"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                color="#08911B"
                hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
            v-model="selected"
            :headers="headersLossAssessors"
            :items="LossAssessors"
            :items-per-page="10"
            
            item-key="name"
            :search="searchAssessor"
            class="px-5"
            no-data-text="No Loss Assessor Attached To This Community"
        >

            <template v-slot:item.actionDel="{ item }">

            <v-icon
                
                class="mr-2 icon-color"
                @click="getLossAssessor(item.loss_assessor_id)"
            >
                mdi-chevron-right
            </v-icon>
            </template>
        </v-data-table>
    </v-card>
<!-- Marketers here -->
    <v-toolbar flat color="#F0FFEA" height="30" class="mt-5 my-3">
        <v-toolbar-title style="color:#62AE32" class="headline">Marketing Consultant</v-toolbar-title>
    </v-toolbar>
    
    <v-card>
        <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
                v-model="searchMarketer"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                color="#08911B"
                hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
            v-model="selected"
            :headers="headersMktnConsultant"
            :items="MarketingConsultant"
            :items-per-page="10"
            :single-select="singleSelect"
            item-key="name"
            :search="searchMarketer"
            class="px-5"
            no-data-text="No Marketing Consultant Attached To This Community Yet"
        >

            <template v-slot:item.actionDel="{ item }">

            <v-icon
                
                class="mr-2 icon-color"
                @click="getMarketingConsultant(item.loss_assessor_id)"
            >
                mdi-chevron-right
            </v-icon>
            </template>
        </v-data-table>
    </v-card>
        
    </div>
    </v-container>

</div>
   
</template>
<script>
    export default {
        name: 'communityMembers',
        components: {
        },

        data: () => ({
            dialog:false,
            address: '',
            contact: '',
            website: '',
            number: '',
            email: '',
            search:'',
            searchMarketer:'',
            searchAssessor:'',
            searchAdmin:'',
            searchClaims:'',
            selectClaimStatus:'Reported',
            selectClaimStatus:'',
            headers: [
                {
                text: 'Name',
                align: 'left',
                sortable: false,
                value: 'name',
                class:'font-weight-black'
                },
                {text: 'Username', value:'username'},
                {text:'Email', value:'email', sortable: false},
                {text:'PhoneNumber', value:'phonenumber', sortable: false},
                { text: '', value: 'action', sortable: false },
                { text: '', value: 'actionDel', sortable: false },
            ],
            headersAdmins: [
                {
                text: 'Name',
                align: 'left',
                sortable: false,
                value: 'name',
                class:'font-weight-black'
                },
                {text: 'Username', value:'username'},
                {text:'Email', value:'email', sortable: false},
                {text:'PhoneNumber', value:'phonenumber', sortable: false},
                { text: '', value: 'action', sortable: false },
                { text: '', value: 'actionDel', sortable: false },
            ],
            headersLossAssessors: [
                {
                    text: 'Name',
                    align: 'left',
                    sortable: true,
                    value: 'name',
                },
                { text: 'Email', value: 'email', sortable:false },

                { text: 'Phone No', value: 'phonenumber', sortable:false },
                { text: 'Username', value: 'username', sortable:false },
                { text: '', value: 'action', sortable: false },
                { text: '', value: 'actionDel', sortable: false },
            ],
            headersMktnConsultant: [
                {
                    text: 'Name',
                    align: 'left',
                    sortable: true,
                    value: 'name',
                },
                { text: 'Email', value: 'email', sortable:false },

                { text: 'Phone No', value: 'phonenumber', sortable:false },
                { text: 'Username', value: 'username', sortable:false },
                { text: '', value: 'action', sortable: false },
                { text: '', value: 'actionDel', sortable: false },
            ],
            claimHeaders: [
                {
                text: 'Name',
                align: 'left',
                sortable: false,
                value: 'name',
                class:'font-weight-black'
                },
                {
                text: 'Username',
                align: 'left',
                sortable: false,
                value: 'policy_holder',
                class:'font-weight-black'
                },
                {text: 'Policy Number', value:'policy_number', sortable:false},
                {text:'Status', value:'status', sortable: false},
                // {text:'Flag', value:'flag', sortable: false},
                { text: '', value: 'action', sortable: false },
            ],
            loader:false,
            claimStatus:['All', 'Reported','Loss Assessor Reccomended Amount','Recommendation Accepted', 'Recommendation Rejected ', 'Consultant Recommended Amount', 'Claims Paid', 'Declined']

        }),
        computed:{
            Members(){
              return this.$store.state.community.communitybyid.members
            },
            LossAssessors(){
              return this.$store.state.community.communitybyid.lossAssessors
            },
            Claims(){
                return this.$store.state.community.communitybyid.claims
            },
            Admins(){
                return this.$store.state.community.communitybyid.admins
            },
            MarketingConsultant(){
                return this.$store.state.community.communitybyid.marketingConsultant            
            }
        },
        methods:{ 
            onChange(event) {
                if (event === 'All'){
                    this.loader=true
                     this.$store.dispatch("ClaimsFilterAll", {communityCode:this.$store.state.community.communitybyid.community_code})
                    .then(()=>{
                        this.loader=false
                    })
                    .catch(()=>{
                        this.loader=false
                    });
                }else{
                    this.loader=true
                    this.$store.dispatch("ClaimsFilter", {status:event, communityCode:this.$store.state.community.communitybyid.community_code})
                    .then(()=>{
                        this.loader=false
                    })
                    .catch(()=>{
                        this.loader=false
                    }); 
                }
            },
            getName(id){
                this.$store.dispatch("MembersById",id)
                .then((success)=>{
                this.$router.push(`/community/members/${success.member[0].username}`)
                })
                .catch(()=>{
                }) 
            },
            getClaims(id){
                this.$store.dispatch("ViewClaim", id)
                .then((success)=>{
                    this.$router.push(`/claims/${success.claim.policy_holder}`)
                })
                .catch(()=>{
                })

            },
            save(){
                this.dialog=false
            },
            close(){
                this.dialog=false
            },
            getMarketingConsultant(id){
            const marketingConsultantId = id
            this.$store.dispatch("getMarketingConsultantById", marketingConsultantId)
            .then((succes)=>{
                this.$router.push(`/marketing_consultants/viewMarketingConsultant/${success.marketer[0].username}`);
            })
            .catch(()=>{
            })
        },
            getLossAssessor(id){
            const lossAssessorId = id
            this.$store.dispatch("getLossAssessorById", lossAssessorId)
            .then((success)=>{
                this.$router.push(`/loss_assessors/viewLossAssessor/${success.assessor[0].username}`);
            })
            .catch(()=>{
            })
        },
        },
        created(){
            this.address = this.$store.state.community.communitybyid.address
            this.email = this.$store.state.community.communitybyid.email
            this.contact = this.$store.state.community.communitybyid.contact_no
            this.number = this.$store.state.community.communitybyid.no_of_members
            this.website = this.$store.state.community.communitybyid.website_url
            this.communityCode = this.$store.state.community.communitybyid.community_code
        }
    }
</script>

<style scoped>
    .title-color{
  color : #62ae32;
}
.consultant{
    background-color: #f0ffea;
    height: 100%;
    background-size: cover;
}
.icon-color{
   color: #B45C5C;
}
.delete-color{
    color: #ff5f58;
}
.btn-style{
    border-radius: 30px;
    text-transform: initial;
}
</style>